/* eslint-disable linebreak-style */
// eslint-disable-next-line linebreak-style
/* eslint-disable max-len */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import { Group } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import RankGraph from '../../../components/Graphics/RankGraph';

class WorkActivityChartRank extends React.Component {
  state = {
    defaultList: [],
    workActivityData: [],
    workActivityInfo: null,
    selectedSlice: null,
  };

  componentDidMount() {
    if (this.props.data) {
      this.fetchPresences();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.department !== this.props.department || prevProps.data !== this.props.data) {
      this.fetchPresences();
    }
  }

  setPieConfig = () => {
    const rank = this.props.ranking.filter((val, i) => i < 3).map(i => [
      {
        id: i.employee.name, "Funcionario": i.count,
      },
    ]);
    return rank.flat();
  }

  onClickSlice = (sliceInfo) => {
    this.props.changefilter(sliceInfo.data.id, 'Ranking');
  }

  fetchPresences = () => {
    const response = this.props.data;
    let workActivityList = [];

    if (response && response.length > 0) {
      workActivityList = response.filter(i => ({
        inParentId: i.inParentId
      }));
    }

    this.setState({
      defaultList: [...workActivityList],
      workActivityData: workActivityList,
      workActivityInfo: this.setPieConfig(),
      selectedSlice: null,
    });
  }

  render() {

    const { changefilter, ranking } = this.props;

    return (
      <Grid>
        <Paper elevation={2} style={{ flexBasis: '40%', margin: 'auto', marginTop: 'initial' }} data-tut="reactour__Faltantes">
          <Typography
            variant="h6"
            component="h4"
            color="textSecondary"
            align="left"
            style={{ padding: 20, fontColor: '#8898AA', fontSize: 15 }}
          >
            {'Ranking de Funcionarios'}
          </Typography>

          <div
            style={{
              height: 300,
              minWidth: 300,
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              cursor: !this.state.workActivityData.length ? 'default' : 'pointer',
            }}
          >
            {
              !this.props.ranking.length ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Group color="disabled" style={{ fontSize: 100, paddingBottom: 20 }} />
                  <Typography component="h3" color="textSecondary" align="center">
                    Nenhum ranking a ser exibido
                  </Typography>
                </div>
              ) :
                <RankGraph data={this.state.workActivityInfo} onClick={this.onClickSlice} />
            }
          </div>
        </Paper>
      </Grid>
    );
  }
}

export default WorkActivityChartRank;